import React from 'react';
import Marker from 'react-leaflet-enhanced-marker';
import { Avatar } from '@mui/material';
import { TextMarker } from '../Map/TextMarker/TextMarker';
import { Pane } from 'react-leaflet';
import { uavColours } from '../../../../constants';
export const transformToLatLng = coords => {
  const { latitude, longitude } = coords;
  return [latitude || 0, longitude || 0];
};
const PilotIcon = props => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white'
      }}>
      <Avatar style={{ backgroundColor: props.color }}>{props.text}</Avatar>
    </div>
  );
};

export const Pilots = props => {
  try {
    return props.data.map(data => {
      if (!data?.pilotInfo) return null;
      const { pilotInfo, uavId } = data;
      const { p1, p2 } = pilotInfo;

      const { location: p1Location } = p1;
      const { location: p2Location } = p2;

      const colour = uavColours[data.uav?.colour];

      return (
        <div key={uavId}>
          {props?.p1 && p1 && (
            <>
              <Pane
                key={`p1-pane${uavId}`}
                name={`p1-pane${uavId}`}
                style={
                  {
                    // zIndex: indexPriority(7)
                  }
                }>
                <Marker
                  key="p1"
                  position={transformToLatLng(p1Location)}
                  icon={
                    <PilotIcon
                      key={uavId + 'p1Icon'}
                      text={'P1'}
                      color={colour}
                    />
                  }
                />
              </Pane>
              <Marker
                key={'Marker2'}
                position={transformToLatLng(p1Location)}
                icon={
                  <TextMarker
                    style={{
                      alignItems: 'center',
                      marginTop: 44
                    }}
                    color={colour}
                    textStyle={{
                      alignText: 'center'
                    }}>{`${uavId}`}</TextMarker>
                }
              />
            </>
          )}
          {props?.p2 && p2 && (
            <>
              <Marker
                key={'Marker2'}
                position={transformToLatLng(p2Location)}
                icon={
                  <PilotIcon
                    key={uavId + 'p1Icon'}
                    text={'P2'}
                    color={colour}
                  />
                }
              />
              <Marker
                key={'Marker3'}
                position={transformToLatLng(p2Location)}
                icon={
                  <TextMarker
                    style={{
                      alignItems: 'center',
                      marginTop: 44
                    }}
                    color={colour}
                    textStyle={{
                      alignText: 'center'
                    }}>{`${uavId}`}</TextMarker>
                }
              />
            </>
          )}
        </div>
      );
    });
  } catch (err) {
    console.error(err);
    return null;
  }
};
